import { MapPin, Calendar, ArrowRight } from 'lucide-react';
import { ITALIAN_UNIVERSITIES } from '@/data/content';
import { useCounsellingModal } from './CounsellingModal';

const Universities = ({ limit }) => {
  const { open } = useCounsellingModal();
  const list = limit ? ITALIAN_UNIVERSITIES.slice(0, limit) : ITALIAN_UNIVERSITIES;

  return (
    <section className="universities-section" data-testid="universities-section">
      <div className="container">
        <div className="section-header">
          <div className="section-eyebrow">Premium Selection</div>
          <h2 className="section-title">Top <span className="gold-gradient">{ITALIAN_UNIVERSITIES.length}+</span> Italian Universities</h2>
          <p className="section-subtitle">
            From the world's oldest university to Italy's leading polytechnics — discover institutions offering globally recognized degrees with zero tuition fees.
          </p>
        </div>

        <div className="university-grid">
          {list.map((uni, idx) => (
            <div
              key={uni.id}
              className="uni-card"
              data-testid={`uni-card-${uni.id}`}
              onClick={() => open({ source: 'university_card', message: `I'm interested in studying at ${uni.name}.`, course: '', country: 'Italy' })}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && open({ source: 'university_card', message: `I'm interested in studying at ${uni.name}.`, country: 'Italy' })}
            >
              <div className="uni-card-num">{String(idx + 1).padStart(2, '0')}</div>
              <h3 className="uni-name">{uni.name}</h3>
              <div className="uni-meta">
                <span className="uni-meta-item">
                  <MapPin size={13} />
                  <span>{uni.city}</span>
                </span>
                <span className="uni-meta-item">
                  <Calendar size={13} />
                  <span>Est. {uni.founded}</span>
                </span>
              </div>
              <p className="uni-desc">{uni.description}</p>
              <span className="uni-cta">
                Apply Through EuroElite <ArrowRight size={14} />
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Universities;
